export const siteData = {
  brand: "BIGGIE POPPINS",
  monogram: "BP",
  eyebrow: "V3B · operator pressure study",
  tagline: "A harder, sharper home base for systems, leverage, and live momentum.",
  intro: "Same person. Different pressure. More edge, more contrast, more sense that everything here is currently in play.",
  ctas: {
    primary: { label: "Open current work", href: "#portfolio" },
    secondary: { label: "Instagram", href: "https://instagram.com/BiggiePoppins" }
  },
  socials: [
    { name: "Instagram", url: "https://instagram.com/BiggiePoppins", icon: "Instagram" },
    { name: "Crafty Systems Labs", url: "https://github.com/Crafty-Systems-Labs", icon: "Github" }
  ],
  signalStrip: ["decision tools", "agent workflows", "offers", "operator os"],
  about: {
    title: "LIVE SYSTEM, NOT JUST A SITE",
    paragraphs: [
      "This direction turns the page into a command surface. Less editorial calm. More active pressure and sharper execution energy.",
      "It still protects the brand, but it feels closer to a live operating system than a polished online brochure."
    ],
    principles: [
      { title: "Signal under pressure", body: "The point is clarity while things are moving, not clarity after the fact." },
      { title: "Execution as identity", body: "The site should feel like a person who ships, tracks, and sharpens." },
      { title: "Leverage over theater", body: "Hard edges are useful only when they imply real capability." }
    ]
  },
  portfolio: [
    { id: 1, title: "Decision surfaces", description: "Interfaces that compress noise and make better calls faster.", category: "Systems", status: "Running", tags: ["signal", "speed", "edge"] },
    { id: 2, title: "Agent workflows", description: "Automation chains that remove drag and convert repetition into leverage.", category: "Automation", status: "Active", tags: ["agents", "ops", "stacking"] },
    { id: 3, title: "Offer pressure tests", description: "Commercial concepts tested against what people actually respond to, not what sounds clever.", category: "Commerce", status: "Testing", tags: ["offers", "market", "response"] },
    { id: 4, title: "Content as signal", description: "Notes and media treated as directional output, not filler for an algorithm.", category: "Media", status: "Intermittent", tags: ["voice", "positioning", "timing"] },
    { id: 5, title: "Physical discipline", description: "Body and schedule as infrastructure for the actual work, not side quests.", category: "Operator", status: "Locked", tags: ["health", "discipline", "consistency"] },
    { id: 6, title: "Creative reconnaissance", description: "Photography and aesthetic study feeding sharper positioning and better design instinct.", category: "Creative", status: "Live", tags: ["taste", "image", "direction"] }
  ],
  blog: [
    { id: 1, title: "What a small operator actually needs from AI", excerpt: "Compression, leverage, speed — not a toy box.", category: "Live note" },
    { id: 2, title: "The difference between momentum and motion", excerpt: "Busyness is easy to fake. Momentum leaves evidence.", category: "Live note" },
    { id: 3, title: "Why every brand needs a pressure-tested point of view", excerpt: "If it collapses under scrutiny, it was never positioning in the first place.", category: "Live note" }
  ],
  contact: {
    title: "BEST LIVE CHANNELS",
    blurb: "This version assumes people are dropping in to gauge current momentum. Instagram shows the surface. Crafty Systems Labs shows the work.",
    availability: [
      "Product and system conversations",
      "Commercial ideas with teeth",
      "Selective collaborations with real upside"
    ]
  }
};
